import { AxiosInstance } from 'axios'
import axiosInstance from '../index'

export interface AuthenticationResponse {
  token: string
  fullname: string
}

class LoginApi {
    private axios: AxiosInstance

    constructor(axios: AxiosInstance) {
      this.axios = axios
    }

    public async login(email: string, password: string): Promise<AuthenticationResponse> {
      const response = await this.axios.post('/login', {
        email,
        password,
      })
      this.axios.defaults.headers.common.Authorization = `Bearer ${response.data.token}`
      return response.data
    }

    public loginAs(token: string): Promise<AuthenticationResponse> {
      return this.axios.post('/login-as', {
        token,
      }).then(response => {
        this.axios.defaults.headers.common.Authorization = `Bearer ${response.data.token}`
        return response.data
      })
    }

    public logout(): Promise<void> {
      return new Promise((resolve) => {
        delete this.axios.defaults.headers.common.Authorization
        resolve()
      })
    }
}

export const loginApi = new LoginApi(axiosInstance)
